import React from 'react';
import { useNavigate } from 'react-router';
import { AppShell } from '../components/layout';

const AITestCasePage = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <AppShell
      user={user}
      onLogout={() => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('user');
        navigate('/auth/login');
      }}
    >
      <div style={{ color: 'var(--text-secondary)' }}>AI Test Case Page (to be implemented)</div>
    </AppShell>
  );
};

export default AITestCasePage;
